/* eslint-disable */
// These are private because we should only use them for cases where you need to tell the user how
// to interact with their browser. https://stackoverflow.com/a/9851769/8107589

declare global {
  interface Document {
    [key: string]: any;
  }
  interface Window {
    [key: string]: any;
  }
}

// https://www.netguru.com/blog/pwa-ios

// https://stackoverflow.com/a/9039885/8107589
export const IsIos = () =>
  ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
    navigator.platform,
  ) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

// Previous version:
// /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());

export const IsStandalone = () =>
  'standalone' in window.navigator && Boolean(window.navigator.standalone);

// Opera 8.0+
export const IsOpera = () =>
  (Boolean(window.opr) && Boolean(window.opr.addons)) ||
  Boolean(window.opera) ||
  navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
export const IsFirefox = () => typeof window.InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
export const IsSafari = () =>
  /constructor/i.test(String(window.HTMLElement)) ||
  (function (p) {
    return p.toString() === '[object SafariRemoteNotification]';
  })(!window.safari || (typeof window.safari !== 'undefined' && window.safari.pushNotification));

// Internet Explorer 6-11
export const IsIE = () => /* @cc_on!@ */ false || Boolean(document.documentMode);

// Edge 20+
export const IsEdge = () => !IsIE() && Boolean(window.StyleMedia);

// Chrome 1 - 79

export const IsChrome = () =>
  // https://stackoverflow.com/a/13808053/8107589
  IsIos()
    ? /CriOS/i.test(navigator.userAgent)
    : Boolean(window.chrome) && (Boolean(window.chrome.webstore) || Boolean(window.chrome.runtime));

// Edge (based on chromium) detection
export const IsEdgeChromium = () => IsChrome() && navigator.userAgent.indexOf('Edg') != -1;

// Blink engine detection
export const IsBlink = () => (IsChrome() || IsOpera()) && Boolean(window.CSS);

export function summarize() {
  const summary = {
    isOpera: IsOpera(),
    isFirefox: IsFirefox(),
    isSafari: IsSafari(),
    isIE: IsIE(),
    isEdge: IsEdge(),
    isChrome: IsChrome(),
    isEdgeChromium: IsEdgeChromium(),
    isBlink: IsBlink(),
    isIos: IsIos(),
    isStandalone: IsStandalone(),
  };
  return summary;
}
